import SideBar from "../components/SideBar"
import {useState,useEffect} from 'react'
import {useDispatch} from "react-redux"
import { addGenre, fetchGenre } from "../store/actions"
import {useNavigate} from "react-router-dom"
import Swal from "sweetalert2"

export default function AddGenre(){
    const dispatch= useDispatch()
    const navigate= useNavigate()
    const [genre,setGenre]= useState({
        name:""
    })

    const inputAddGenre = (e)=>{
        const{name,value}= e.target
        setGenre({
        ...genre,
        [name]:value})
    }

    const AddGenreHandler= (e)=>{
        e.preventDefault();
           dispatch(addGenre(genre))
           .then((response)=>{
            return response.json()
         })
           .then((data)=>{
            if(data.message){
                Swal.fire({
                    icon:'error',
                    title: data.message
                   })
                navigate('/addGenre')
            }else{
                Swal.fire({
                    icon:'success',
                    title: "Success add genre"
                   })
                navigate('/genre')
                dispatch(fetchGenre())
            }
        })
        .catch((error)=>{
            console.log(error);
        })
    }


    return(
        <div>
            <SideBar/>
            <div>
                <div>
                <form onSubmit={AddGenreHandler}>
<div className="justify-center items-center flex flex-col" style={{height:"100vh"}}>
<div className="text-center rounded-lg pt-20" style={{width: "1000px", height: "800px"}}>
   <p className="font-bold" style={{fontSize: "15pt"}}>Add Genre</p>
   <div className="pt-5">
   <label>Name:</label><br/>
   <input value={genre.name} name="name" onChange={inputAddGenre}  type="text" style={{width: "300px", height:"35px"}} placeholder="Title" className="border-2 rounded-md pl-2"/>
   </div>
   <div className="pt-5 pb-10">
   <button className="bg-purple-400 h-8 rounded-lg hover:bg-purple-300"  style={{width: "300px", height:"35px"}}>Submit</button>
   </div>
</div>
</div>
</form>
                </div>
            </div>
        </div>
    )
}